import "../css/EventsFrontpage.css";
import "bootstrap/dist/css/bootstrap.min.css";
import React, { useEffect, useState } from "react";
import Flag from "react-world-flags";
import { useEvents } from "../../src/hooks/useEvents";
import useSeason from "../hooks/useSeason";
import { useNavigate } from "react-router-dom";
import SeasonEndLeaderboard from "./SeasonEndLeaderboard";

const EventsFrontpage = () => {
  const { events, error, loading } = useEvents();
  const { currentSeason, fetchCurrentSeason } = useSeason();
  const [daysRemaining, setDaysRemaining] = useState(null);
  const navigate = useNavigate();

  const formatDate = (unixTimestamp) => {
    const date = new Date(unixTimestamp);
    return date.toLocaleDateString("da-DK", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  // Filter out events that are finished
  const filteredEvents = events.filter((event) => {
    return event.isFinished === false && event.season === currentSeason?._id;
  });

  useEffect(() => {
    fetchCurrentSeason();

    if (currentSeason) {
      const now = new Date();
      const endDate = new Date(currentSeason.end);
      const timeDiff = endDate - now;
      const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
      setDaysRemaining(days);
    }

    const eventContent = document.querySelector(".eventsBox");
    if (eventContent) {
      const handleScroll = (event) => {
        if (event.deltaY !== 0) {
          eventContent.scrollLeft += event.deltaY;
          event.preventDefault();
        }
      };
      eventContent.addEventListener("wheel", handleScroll);
      return () => {
        eventContent.removeEventListener("wheel", handleScroll);
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [events]);

  const shouldShowSeasonEndLeaderboard =
    filteredEvents.length === 0 &&
    daysRemaining !== null &&
    daysRemaining <= 30 &&
    daysRemaining >= 0;

  if (shouldShowSeasonEndLeaderboard) {
    return <SeasonEndLeaderboard />;
  }

  return (
    <div className="eventsFrontpage-container">
      <div className="teamWinner-title-wrapper">
        <h1
          className="title-events hoverable"
          onClick={() => navigate("/events")}
        >
          Featured Events
        </h1>
      </div>

      <div className="eventsBox">
        {loading && <div className="loader" />}
        {filteredEvents.length > 0
          ? filteredEvents.map((event, index) => (
              <div key={index} className="event-wrapper">
                <div
                  className="events"
                  onClick={() => navigate(`/event/${event.hltv_id}`)}
                >
                  <div className="event-content">
                    {event.image && (
                      <img
                        className="event-image"
                        src={event.image}
                        alt="event"
                      />
                    )}
                    <div className="event-info">
                      {event.name && <p className="event-name">{event.name}</p>}
                      {event.isLive && <p className="event-live">Live</p>}
                      {event.isActive && !event.isLive && (
                        <p className="event-active">Active</p>
                      )}
                      {!event.isActive && !event.isLive && (
                        <p className="event-upcoming">Upcoming</p>
                      )}

                      <div className="event-details">
                        {event.startDate && (
                          <p className="event-date">
                            {formatDate(event.startDate)} -{" "}
                            {formatDate(event.endDate)}
                          </p>
                        )}
                        {event.location && (
                          <p className="event-location">
                            Location:{" "}
                            <Flag
                              className="flag"
                              code={event.location.code}
                              fallback={<Flag className="flag" code="EU" />}
                            />{" "}
                            {event.location.name}
                          </p>
                        )}
                        {event.prizePool && (
                          <p className="event-prizepool">
                            Prize pool: {event.prizePool}
                          </p>
                        )}
                        <b
                          className="moreinfo"
                          onClick={(e) => {
                            e.stopPropagation();
                            window.open(
                              `https://www.hltv.org/events/${event.hltv_id}/${event.name}`,
                              "_blank"
                            );
                          }}
                        >
                          More stats
                        </b>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))
          : error && (
              <div className="event-frontpage-info">
                NO FEATURED EVENTS AT THE MOMENT
              </div>
            )}
      </div>
    </div>
  );
};

export default EventsFrontpage;
